/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthSupportsRequest } from '../../models/auth-supports-request';

export interface GetAuthSupportsRequest$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getAuthSupportsRequest(http: HttpClient, rootUrl: string, params: GetAuthSupportsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportsRequest>> {
  const rb = new RequestBuilder(rootUrl, getAuthSupportsRequest.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthSupportsRequest>;
    })
  );
}

getAuthSupportsRequest.PATH = '/custom/auth-supports-requests/{uid}';
